import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CategoryDTO } from '../company-user/userProfileDTO.model';
import { EquipmentDTO } from '../Models/Equipment.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import {environment} from '../../environments/environment';

declare var swal: any;

@Component({
  selector: 'app-equipments',
  templateUrl: './equipments.component.html',
  styleUrls: ['./equipments.component.scss'],
  providers: [SrubUpService]
})
export class EquipmentsComponent implements OnInit {
  public baseurl: string = environment.base_url;
  imageUploadApiUrlLength: number;
  showAddCategoryInput: boolean;
  EquipmentId: number;
  equipments: Array<EquipmentDTO>;
  equipmentCategories: Array<string>;
  equipmentName: string;
  categoryName: string;
  newCategoryName: string
  specification: string;
  quantity: number;
  imagePath: string;

  index: boolean;
  edit: boolean; 
  codeValue: string; 
  descriptionValue: string; 
  
  mpId: number;
  profileId: number;
  createNew: boolean;
  public loading = false;
  nextButtonDisabled: boolean;
  isMobile: number;
  invisible: number;  
  editvisi: number;
  showEditingDiv: number;
  iValue: number;
  uploadUrl: string;
  loginUserId: number;
  myHeaders: { [name: string]: any };
  tempUrl:Array<string>;

  constructor(private appUserDetails: AppWideUser, private token: Token, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.nextButtonDisabled = true;
    this.index = true;
    this.codeValue = "";
    this.invisible = 0;
    this.editvisi = 0;
    this.descriptionValue = "";
    this.showEditingDiv = -1;
    this.iValue = -1;
    this.EquipmentId = 0;
    this.equipmentCategories = new Array<string>();
    this.equipments = new Array<EquipmentDTO>();
    this.showAddCategoryInput = false;
    this.loginUserId = this.appUserDetails.UserId;
      this.myHeaders={ 'Authorization': 'Bearer ' + this.token.access_token,
       'UserId': this.appUserDetails.UserId,
       'ModulePath' : "Equipment"
    };
    this.tempUrl= new Array<string>();
    this.uploadUrl = this.baseurl+"api/Speciality/UploadImage?userId=" + this.loginUserId;
    this.imageUploadApiUrlLength = (this.baseurl+"api/Speciality/GetUploadedImage?imageName=").length;
  }

  showAddCategoryInputField() {
    this.showAddCategoryInput = true;
  }

  	GetImage(imageSrc)
  { 
    imageSrc.forEach(element => {
       this.scrubUpService.GetImage(this.token, element ,this.appUserDetails.UserId).subscribe(ab => { 
         this.equipments.forEach(a => {
           if(a.ImagePath==element)
           {
             a.ImageBase64= "data:image/png;base64," + ab
           }
         });
    });

    });
  }

  GetEquipmentList() {
    this.loading = true;
    this.scrubUpService.GetEquipmentList(this.token, Globals.LoginUsrId).subscribe(x => {
      if (x != null && x != undefined) {
        this.equipments = x;
        this.equipments.forEach(element => {
          //element.ImagePath =this.token.webAPIURL+"Speciality/GetUploadedImage?imageName="+element.ImagePath;
           this.tempUrl.push(element.ImagePath);
        });
        this.GetImage(this.tempUrl);
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  GetEquipmentCategoryList() {
    this.loading = true;
    this.scrubUpService.GetEquipmentCategoryList(this.token, Globals.LoginUsrId).subscribe(x => {
      if (x != null && x != undefined) {
        this.equipmentCategories = x;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }

  UserClick(btnCount) {
    this.edit = false;
    if (btnCount == 1) {
      this.edit = true;
      this.showEditingDiv = -1;
      this.equipmentName = "";
      this.categoryName = "";
      this.imagePath = "";
      this.EquipmentId = 0;
    }
    if (btnCount == 3) {
      this.showAddCategoryInput = false;
      this.edit = false;
      this.invisible = 0;
      this.equipmentName = "";
      this.categoryName = "";
    }
  }

  OnUploadFinished(response: any) {
    if (response.serverResponse.response.status == "200") {
      this.imagePath = response.serverResponse.response._body;
      this.imagePath = this.imagePath.substring(1, this.imagePath.length - 1);
    }
  }

  cancelAddNewCategory() {
    this.showAddCategoryInput = false;
  }

  addNewCategory() {
    let category: CategoryDTO;
    category = new CategoryDTO();
    category.CategoryName = this.newCategoryName;
    //category.Equipments = [];
    this.loading = true;
    this.scrubUpService.AddCategory(this.token, category,this.appUserDetails.UserId).subscribe(x => {
      if (x == "success") {
        //this.UserClick(3);
        this.GetEquipmentCategoryList();
        this.newCategoryName = "";
        this.showAddCategoryInput = false;
      }
      else {

      }
      this.loading = false;
    });
  }

  OnCancel() {
    this.showEditingDiv = -1;
    this.editvisi = 0;
    this.equipmentName = "";
    this.categoryName = "";
    this.imagePath = "";
    this.EquipmentId = 0;
  }

  EditEquipment(equipmntCategoryName: string, equipmntName: string, equipmntId: number, equipmntImagePath: string, index: number) {
    this.editvisi = 1;
    // this.correctiveActionUpdateExists=false;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.categoryName = equipmntCategoryName;
      this.equipmentName = equipmntName;
      this.EquipmentId = equipmntId;
      this.imagePath = equipmntImagePath;
      this.edit = false;
    }
    else {
      this.categoryName = equipmntCategoryName;
      this.equipmentName = equipmntName;
      this.EquipmentId = equipmntId;
      this.imagePath = equipmntImagePath;
      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }
  }

  UpdateEquipment(index) {
    let equipment: EquipmentDTO;
    equipment = new EquipmentDTO();
    equipment.Name = this.equipmentName;
    equipment.CategoryName = this.categoryName;
    //equipment.ImagePath = this.imagePath;
    equipment.ImagePath = (this.imagePath == this.equipments[index].ImagePath)? this.imagePath.slice(this.imageUploadApiUrlLength):this.imagePath; 
    equipment.ID = this.EquipmentId.toString();
    this.loading = true;
    this.scrubUpService.AddEquipment(this.token, equipment,this.appUserDetails.UserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Equipment Updated Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.OnCancel();
        this.GetEquipmentList();
      }
      else {

      }
      this.loading = false;
    });
  }

  AddEquipment() {
    let equipment: EquipmentDTO;
    equipment = new EquipmentDTO();
    equipment.Name = this.equipmentName;
    equipment.CategoryName = this.categoryName;
    equipment.ImagePath = this.imagePath;
    equipment.ID = "0";
    this.loading = true;
    this.scrubUpService.AddEquipment(this.token, equipment,this.appUserDetails.UserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Equipment Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.UserClick(3);
        this.GetEquipmentList();
        this.equipmentName = "";
        this.specification = "";
        this.quantity = null;
      }
      else {

      }
      this.loading = false;
    });
  }

  ngOnInit() {
    this.GetEquipmentList();
    this.GetEquipmentCategoryList();
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/equipments/equipments.component.ts